/**
 * Clamp a fixed-position element so it stays within the viewport.
 * Positions the element relative to its parent's bounding rect,
 * offset by the given left value, then adjusts to prevent overflow.
 *
 * @param {HTMLElement} el       – the element to position
 * @param {Object}      options
 * @param {number}      [options.leftOffset=0]  – horizontal offset from parent left
 * @param {number}      [options.margin=8]      – minimum gap from viewport edges
 */
export const clampToViewport = (el, { leftOffset = 0, margin = 8 } = {}) => {
  const parent = el.parentElement;
  if (!parent) return;

  const parentRect = parent.getBoundingClientRect();
  const elHeight = el.offsetHeight;
  const elWidth = el.offsetWidth;

  let top = parentRect.top;
  let left = parentRect.left + leftOffset;

  if (top + elHeight > window.innerHeight - margin) {
    top = window.innerHeight - margin - elHeight;
  }
  if (top < margin) {
    top = margin;
  }
  if (left < margin) {
    left = margin;
  }
  if (left + elWidth > window.innerWidth - margin) {
    left = window.innerWidth - margin - elWidth;
  }

  el.style.top = `${top}px`;
  el.style.left = `${left}px`;
};

